import type { LegDTO, PlaceAllocationDTO } from '@/types/dto/agent';

export const getPlaceIconName = (
  placeAllocation?: PlaceAllocationDTO | null
): 'seat' | 'compartment' | 'bed' => {
  if (!placeAllocation) return 'seat';

  const { accomodationType } = placeAllocation;

  if (accomodationType === 'SEAT') {
    return 'seat';
  } else if (accomodationType === 'BED') {
    return 'bed';
  }

  return 'compartment';
};

enum TransportType {
  HIGH_SPEED_TRAIN = 'HIGH_SPEED_TRAIN',
  INTERCITY_REGIONAL = 'INTERCITY_REGIONAL',
  LONG_DISTANCE = 'LONG_DISTANCE',
  LOCAL_TRAIN = 'LOCAL_TRAIN',
  LOCAL_BUS = 'LOCAL_BUS',
  TRAIN = 'TRAIN',
  BUS = 'BUS',
  WALK = 'WALK',
}

export type PtModeIconName = 'train' | 'bus' | 'walk';

export const getPtModeIconName = (ptMode: LegDTO['ptMode']): PtModeIconName => {
  switch (ptMode?.code?.toUpperCase()) {
    case TransportType.HIGH_SPEED_TRAIN:
    case TransportType.INTERCITY_REGIONAL:
    case TransportType.LOCAL_TRAIN:
    case TransportType.TRAIN:
      return 'train';
    case TransportType.BUS:
    case TransportType.LONG_DISTANCE:
    case TransportType.LOCAL_BUS:
      return 'bus';
    case TransportType.WALK:
      return 'walk';
    default: {
      return 'train';
    }
  }
};
